import { useState, useEffect, useRef } from "react";
import { Form, Row, Col, Input, Button, message, Modal } from "antd";
import { useHistory } from "react-router-dom";
import { clock } from "../../utils/clock";
import { v4 as uuidv4 } from "uuid";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { Scrollbars } from "react-custom-scrollbars";
import POSLogo from "../../assets/images/icon.png";
import leftLoading from "../../assets/images/opo.gif";
import db from "../../database";
import data from "../../constants/opentillClosetill.json";
import "../style.css";
import "../Till/TillScreens.css";
import dayjs from "dayjs";
import { getOAuthHeaders } from "../../constants/oAuthValidation";
import { getMultilingualText } from "../../utils/getMultilingualText";
import LoadingScreen from "../PointOfSale/Retail/SuperMarket/LoadingScreen";
import { upsertPOSLogService, upsertTill } from "../../services";
// import { socket, updateSocketAuth } from "../../socket";
import messages from "../../errors/messages.en-IN.json";
import useAuthStore from "../../stores/useAuthStore";
import usePOSConfigStore from "../../stores/usePOSConfigStore";
import useSessionStore from "../../stores/useSessionStore";

const OpenTill = () => {
  const history = useHistory();
  const tillData = useAuthStore((s) => s.tillData);
  const currenciesList = tillData?.tillAccess?.csBunit?.currencies;
  const [loading, setLoading] = useState(false);
  const paymentMethodList = tillData?.tillAccess?.csBunit?.paymentMethodList || [];
  const [noteValue, setNoteValue] = useState("");
  const [isCashPayment, setIsCashPayment] = useState(false);
  const [isExecuting, setIsExecuting] = useState(false);
  const [currencyType, setCurrencyType] = useState({
    currSymbolLeft: "₹",
    currSymbolRight: "",
    stdPrecision: 2,
  });
  const posConfig = usePOSConfigStore((s) => s.posConfig);

  const formattedDateTime = `${new Date().toLocaleTimeString()} | ${new Date().toLocaleDateString("en-US", {
    weekday: "long", // Full day name (e.g., Wednesday)
    day: "numeric", // Day of the month (e.g., 28)
    month: "long", // Full month name (e.g., June)
    year: "numeric", // Full year (e.g., 2023)
  })}`;

  useEffect(() => {
    const run = async () => {
      const tillSession = useSessionStore.getState().tillSession;
      if (tillSession && tillSession.tillStatus === "open") {
        try {
          const matchingEvents = await db.tillEvents
            .where("tillSessionId")
            .equals(tillSession.tillSessionId)
            .toArray();
          const openEvent = matchingEvents?.find((e) => e.tillStatus === "open");
          if (openEvent) {
            history.push("/pos");
            return;
          }
        } catch (err) {
          console.error("[OpenTill] Error verifying tillSession:", err);
        }
        useSessionStore.getState().setTillSession(null);
      }
      if (!tillSession || !useSessionStore.getState().tillSession) {
        await db.tillRegistrations
          .toArray()
          .then((reg) => {
            if (reg.length > 0) {
              const tillAccess = reg[0]?.tillAccess?.[0];
              if (tillAccess) {
                const csBunit = tillAccess.csBunit;
                if (csBunit && csBunit.csCurrency) {
                  const curList = csBunit.csCurrency;
                  const csCurrencyId = curList?.csCurrencyId;
                  if (csCurrencyId) {
                    localStorage.setItem("csCurrencyId", csCurrencyId);
                    setCurrencyType({
                      currSymbolLeft: curList.symbolrightside ? "" : curList.currSymbol,
                      currSymbolRight: curList.symbolrightside ? curList.currSymbol : "",
                      stdPrecision: curList.stdPrecision || 2, // Default precision if not available
                    });
                  }
                }
              }
            }
          })
          .catch((err) => {
            console.error("Error fetching till registration data", err);
          });
      }
    };
    run();
  }, []);

  const [denominations, setDenominations] = useState([]);

  useEffect(() => {
    const run = async () => {
      const modifiedCurrenciesList = currenciesList[0].denominations?.map((denomItem, denomIndex) => ({
        ...denomItem,
        count: 0,
        amount: 0,
      }));
      const sortedDenominations = modifiedCurrenciesList?.sort((a, b) => a.value - b.value);
      setDenominations([...sortedDenominations]);
      const cashPayment = paymentMethodList.find((p) => p.name.toLowerCase() === "cash");
      if (!cashPayment) {
        setIsCashPayment(true);
        excuteOpenTill();
      }
    };
    run();
  }, []);

  const currentDate = new Date().toLocaleDateString();
  const [displayClock, setDisplayClock] = useState("");
  useEffect(() => {
    setDisplayClock(clock());
    const timerId = setInterval(() => setDisplayClock(clock()), 1000);
    return () => {
      clearTimeout(timerId);
    };
  }, []);

  const [totalAmount, setTotalAmount] = useState(
    posConfig?.retainCashforNextShift === "Y" ? useAuthStore.getState().tillData?.tillAccess?.cwrTill?.cashToKeep || 0 : 0
  );

  const onFieldInput = (e) => {
    const { name, value } = e.target;
    const denominationName = parseFloat(name);
    const denominationValue = parseInt(value);
    const denominationAmount = denominationName * denominationValue;
    const di = denominations.findIndex((d) => d.value === denominationName);
    if (di === -1) return;
    denominations[di].count = isNaN(denominationValue) ? "" : denominationValue;
    denominations[di].amount = isNaN(denominationAmount) ? 0 : denominationAmount;
    let total = 0;
    denominations.forEach((denom) => {
      total += denom.amount;
    });
    setTotalAmount(total + useAuthStore.getState().tillData.tillAccess.cwrTill.cashToKeep);
    setDenominations([...denominations]);
  };

  const onFieldOut = (e) => {
    if (e.target.value === "") {
      const di = denominations.findIndex((d) => d.value === parseFloat(e.target.name));
      if (di === -1) return;
      denominations[di].count = 0;
      setDenominations([...denominations]);
    }
  };

  const onFieldButton = (field, action) => {
    if (action === "plus") denominations[field].count += 1;
    if (action === "minus" && denominations[field].count > 0) denominations[field].count -= 1;
    const denominationAmount = denominations[field].value * denominations[field].count;
    const denominationAmountValue = isNaN(denominationAmount) ? 0 : denominationAmount;
    denominations[field].amount = denominationAmountValue;
    let total = 0;
    denominations.forEach((denom) => {
      total += denom.amount;
    });
    setTotalAmount(total + (posConfig?.retainCashforNextShift === "Y" ? useAuthStore.getState().tillData.tillAccess.cwrTill.cashToKeep : 0));
    setDenominations([...denominations]);
  };

  const confirmBtnRef = useRef(null);

  const excuteOpenTill = async () => {
    if (paymentMethodList.length === 0) {
      Modal.error({
        title: "Error",
        content: "Payment methods are not configured for this business unit. Please contact the administrator.",
        onOk: () => {
          history.push("/sign-in");
        },
      });
      return;
    }
    setLoading(true);
    if (isExecuting) {
      setLoading(false);
      return; // If already executing, prevent re-triggering
    }
    setIsExecuting(true);
    const authHeaders = getOAuthHeaders();
    if (authHeaders && authHeaders.access_token) {
      if (confirmBtnRef?.current) {
        confirmBtnRef.current.disabled = true;
      }
      const tillSessionId = uuidv4().replace(/-/g, "").toUpperCase();
      const tillData = useAuthStore.getState().tillData;
      const userData = useAuthStore.getState().userData;
      const user = userData?.user || "";
      const openTillData = {
        tillSessionId: tillSessionId,
        tillStatus: "open",
        isSynced: 0,
        openingTime: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        // Business date this session is booked under (same source as tillCash.date below).
        // For a next-business-date session it is a future date; the close screen uses this
        // to hide "Close Store" until the calendar catches up. Set fresh every open — no stale risk.
        businessDate: useSessionStore.getState().nextBusinessDate
          ? dayjs(useSessionStore.getState().nextBusinessDate).format("YYYY-MM-DD")
          : dayjs(new Date()).format("YYYY-MM-DD"),
        closingTime: null,
        openingCashDenominations: denominations,
        closingCashDenominations: null,
        openingCash: totalAmount,
        closingCash: 0,
        totalOpeningAmount: totalAmount,
        totalClosingExpectedAmount: 0,
        totalClosingTransactions: 0,
        totalClosingAmount: 0,
        user: user,
      };

      const ordersData = {
        tillSessionId: tillSessionId,
        tillStatus: "open",
        date: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        netTotal: 0,
        grossTotal: 0,
        totalTax: 0,
        items: [],
        netReturnTotal: 0,
        grossReturnTotal: 0,
        totaReturnlTax: 0,
        salesTransactions: 0,
        returnsTransactions: 0,
        salesTax: [],
        returnTax: [],
      };

      const paymentsData = {
        tillSessionId: tillSessionId,
        tillStatus: "open",
        date: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        payments: paymentMethodList || [],
      };

      if (posConfig?.DON === "Y") {
        const timeMark = dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss");
        const currentDate = new Date().toLocaleDateString("zh-Hans-CN");
        const dayOpeningArray = [];
        const trxId = uuidv4().replace(/-/g, "").toUpperCase();
        dayOpeningArray.push(`{
          type: "DON",
          action: "LOG",
          description: "${timeMark}",
          date: "${currentDate}",
          time: "${timeMark}",
          orderNo: "",
          remarks: "",
          transactionId: "${trxId}",
          status: "SCS",
          duration: null
        }`);

        try {
          const tillId = tillData?.tillAccess?.cwrTill?.cwrTillID || "";
          const userId = tillData?.tillAccess?.csUserId || "";
          const bUnitId = tillData?.tillAccess?.csBunit?.csBunitId || "";

          if (!tillId || !userId || !bUnitId || !dayOpeningArray) {
            console.error("Missing required fields for upsertPOSLog mutation");
            return;
          }
          upsertPOSLogService(tillId, userId, bUnitId, dayOpeningArray).catch(() => {});
        } catch (error) {
          console.error("Error during upsertPOSLog mutation:", error);
        }
      }

      if (confirmBtnRef.current) {
        confirmBtnRef.current.disabled = false;
      }

      const cashEventDetails = openTillData.openingCashDenominations.map((denomination) => ({
        cwrCashEventdetailsID: uuidv4().replace(/-/g, "").toUpperCase(),
        count: denomination.count || 0,
        amount: denomination.amount || 0,
        denomination: denomination.value || "",
      }));

      const tillCashData = tillData?.tillAccess?.csBunit?.paymentMethodList.map((payment) => {
        const isCash = payment.name.toLowerCase() === "cash";

        const rawNextBusinessDate = useSessionStore.getState().nextBusinessDate;
        // Always normalize to YYYY-MM-DD (date-only) for the tillCash.date field
        const nextBusinessDate = rawNextBusinessDate ? dayjs(rawNextBusinessDate).format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD");
        return {
          cwrTillCashId: uuidv4().replace(/-/g, "").toUpperCase(),
          date: nextBusinessDate,
          finPaymentmethodId: payment?.finPaymentmethodId || "",
          finFinancialAccount2Id: null,
          opening: parseFloat(isCash ? totalAmount : 0).toFixed(currencyType.stdPrecision),
          opentime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
          closetime: null,
          notes: noteValue || "No Notes",
          sales: 0,
          netsales: 0,
          cashin: 0,
          cashout: 0,
          retainAmt: 0,
          closing: 0,
          returns: 0,
          iscash: 1,
          isclose: 0,
          pettyCashIn: 0,
          pettyCashOut: 0,
          cashInOut: [],
          cashEvents: [
            {
              cwrCashEventsID: uuidv4().replace(/-/g, "").toUpperCase(),
              amount: isCash ? openTillData.openingCash : 0,
              expected: 0,
              diff: 0,
              transactionCount: 0,
              type: "Open",
              description: "",
              cashEventDetails: isCash ? cashEventDetails : [],
            },
          ],
        };
      });

      let taxInfoData = {
        cwrTillID: tillData?.tillAccess?.cwrTill?.cwrTillID || "",
        csbunitID: tillData?.tillAccess?.csBunit?.csBunitId || "",
        csclientID: tillData?.tillAccess?.csClientId || "",
        created: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        createdby: tillData?.tillAccess?.csUserId || "",
        updated: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        updatedby: tillData?.tillAccess?.csUserId || "",
        openTill: "Y",
        storeDailyOpsTillid: null,
        tillCash: tillCashData,
      };

      const stringifiedData = JSON.stringify(taxInfoData);
      const newStringifiedFields = stringifiedData.replace(/\\"/g, '\\"');
      const newStringRequest = JSON.stringify(newStringifiedFields);
      try {
        const response = await upsertTill(newStringRequest);
        const upsertTillResponse = response?.data?.data?.upsertTill;

        if (upsertTillResponse?.status === "200") {
          const storeDailyOpsTillid = upsertTillResponse.tillCash[0]?.storeDailyOpsTillid;
          useSessionStore.getState().setTillSession(openTillData);
          // Clear nextBusinessDate after consumption — prevents stale dates in future sessions
          useSessionStore.getState().setNextBusinessDate(null);
          localStorage.setItem("tillCash", JSON.stringify(upsertTillResponse.tillCash));
          await db.tillEvents.add({
            ...openTillData,
            storeDailyOpsTillid,
          });
          await db.ordersData.add({ ...ordersData, storeDailyOpsTillid });
          await db.paymentsData.add({ ...paymentsData, storeDailyOpsTillid });
          // if (socket) {
          //   const tillId = tillData?.tillAccess?.cwrTill?.till;
          //   const storeId = tillData?.tillAccess?.csBunit?.csBunitId;
          //   if (tillId && storeId) {
          //     updateSocketAuth(tillId, storeId);
          //   }
          // } else {
          //   console.error("Socket not initialized. Ensure socketServerUrl is defined.");
          // }
          history.push("/pos");
        } else {
          useSessionStore.getState().setTillSession(null);
          message.error(upsertTillResponse?.message || `${messages.errors.till_management.till_upsert_failed}`);
          setIsExecuting(false);
        }
      } catch (error) {
        console.error("Error during upsertTill:", error);
        setIsExecuting(false);
      }
    }
    setLoading(false);
  };

  const focusFirstElement = () => {
    setTimeout(() => {
      // cancelBtnRef.current.focus();
    }, 100);
  };

  const resetFocus = (index) => {
    if (index + 1 === denominations.length) {
      focusFirstElement();
    }
  };

  let reconstructedObject;

  const rawtillAccessMeta = tillData?.tillAccess?.tillAccessMeta;
  if (rawtillAccessMeta) {
    const rawDataArray = tillData?.tillAccess?.tillAccessMeta;

    // Find the object with the key "Open Till"
    const openTillObject = rawDataArray.find((item) => item.key === "Open Till");

    // Access the value property of the found object
    const openTillValue = openTillObject?.value;

    if (openTillValue !== undefined) {
      // Clean up the string (remove extra characters)
      const cleanedData = openTillValue.replace(/[{}"]/g, "");

      // Split the string into key-value pairs
      const keyValuePairs = cleanedData.split(",");

      // Create an object from key-value pairs
      reconstructedObject = {};
      keyValuePairs.forEach((pair) => {
        // Check if the pair contains a colon
        if (pair.includes(":")) {
          const [key, value] = pair.split(":");

          // Check if both key and value are not undefined before trimming
          if (key !== undefined && value !== undefined) {
            reconstructedObject[key.trim()] = value.trim();
          }
        }
      });
    } else {
      // Handle the case where openTillValue is undefined
      console.error("openTillValue is undefined");
    }
  }

  const tillData1 = tillData?.tillAccess?.cwrTill;
  const cashToKeep = tillData1 ? tillData1?.cashToKeep : 0;

  return (
    <>
      {loading && isCashPayment ? (
        <LoadingScreen
          POSLogo={POSLogo}
          formattedDateTime={formattedDateTime}
          clock1={displayClock}
          leftLoading={leftLoading}
          percent={99}
          productCategoryPercentage={100}
          productPercentage={100}
          promotionPercentage={100}
        />
      ) : (
        <div className="till-screen">
          <header className="till-header">
            <img src={POSLogo} onClick={() => history.push("/")} className="till-header__logo" style={{ cursor: "pointer" }} alt="" />
            <span className="till-header__title">{getMultilingualText("Open Till")}</span>
          </header>
          <div className="till-panel">
            <div className="till-panel__main">
              <div className="till-card">
                <div className="till-card__header">
                  <div className="till-denom-table__cell--denom till-card__header-col">
                    <span>{getMultilingualText("Denomination")}</span>
                  </div>
                  <div className="till-denom-table__cell--count till-card__header-col">
                    <span>{getMultilingualText("Count")}</span>
                  </div>
                  <div className="till-denom-table__cell--total till-card__header-col">
                    <span>{getMultilingualText("Total Amount")}</span>
                  </div>
                </div>
                <div className="till-card__body">
                  <Scrollbars className="tillScroll">
                    {denominations.map((denom, index) => (
                      <div className="till-denom-table__row" key={denom.value}>
                        <div className="till-denom-table__cell till-denom-table__cell--denom">
                          <Input tabIndex={-1} readOnly={true} className="till-denom-table__value" value={denom.value} />
                        </div>
                        <div className="till-denom-table__cell till-denom-table__cell--count">
                          <div className="till-denom-counter">
                            <button className="till-denom-counter__btn" type="button" onClick={() => onFieldButton(index, "minus")}>
                              <MinusOutlined />
                            </button>
                            <Form.Item onBlur={() => resetFocus(index)} className="till-denom-counter__input-wrap" style={{ marginBottom: 0 }}>
                              <Input tabIndex={0} name={`${denom.value}`} value={denom.count} className="till-denom-counter__input" onChange={onFieldInput} onBlur={onFieldOut} />
                            </Form.Item>
                            <button className="till-denom-counter__btn" type="button" onClick={() => onFieldButton(index, "plus")}>
                              <PlusOutlined />
                            </button>
                          </div>
                        </div>
                        <div className="till-denom-table__cell till-denom-table__cell--total">
                          <Input
                            tabIndex={-1}
                            className="till-denom-table__total"
                            readOnly={true}
                            value={`${currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""} ${denom.amount} ${
                              currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""
                            }`}
                          />
                        </div>
                      </div>
                    ))}
                    <span tabIndex={0}></span>
                  </Scrollbars>
                </div>
              </div>
            </div>
            <div className="till-panel__sidebar">
              <div className="till-card--sidebar">
                <p className="till-summary__opened-on">{getMultilingualText("Opened On")}</p>
                <div className="till-summary__datetime">
                  <span>{currentDate}</span>
                  <span>{displayClock}</span>
                </div>
                <p className="till-summary__section-title--lg">
                  {getMultilingualText("Transactions")}
                </p>
                <Form>
                  <Form.Item style={{ marginBottom: "2vh" }}>
                    <p className="till-summary__field-label">{getMultilingualText("Opening Amount")}</p>
                    <Input
                      placeholder="₹0"
                      tabIndex={-1}
                      value={`${currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""} ${parseFloat(totalAmount)}   ${
                        currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""
                      }`}
                      readOnly={true}
                      className="transactionAmtInput"
                      style={{ marginBottom: "2vh", height: "6vh" }}
                    />

                    <p className="till-summary__field-label">{getMultilingualText("Notes")}</p>
                    <Input
                      tabIndex={-1}
                      placeholder="Enter note"
                      onChange={(e) => setNoteValue(e.target.value)}
                      className="transactionAmtInput"
                      style={{ height: "6vh" }}
                    />
                  </Form.Item>
                </Form>

                <Scrollbars className="openTillScroll1">
                  <div className="till-summary__row">
                    <p className="till-summary__label">{getMultilingualText("Outlet")}</p>
                    <p className="till-summary__value">{tillData.tillAccess.csBunit.name}</p>
                  </div>

                  <div className="till-summary__row">
                    <p className="till-summary__label">{getMultilingualText("Register")}</p>
                    <p className="till-summary__value">{tillData.tillAccess.cwrTill.till}</p>
                  </div>

                  <div className="till-summary__row" style={{ display: reconstructedObject ? (reconstructedObject.OpeningAmount === "Y" ? "flex" : "none") : "flex" }}>
                    <p className="till-summary__label">{getMultilingualText("Opening Amount")}</p>
                    <p className="till-summary__value">{currenciesList[0].currSymbol}0</p>
                  </div>

                  <div className="till-summary__row" style={{ display: reconstructedObject ? (reconstructedObject.CashSaleAmount === "Y" ? "flex" : "none") : "flex" }}>
                    <p className="till-summary__label">{getMultilingualText("Cash Sale Amount")}</p>
                    <p className="till-summary__value">{currenciesList[0].currSymbol}0</p>
                  </div>

                  <div className="till-summary__row" style={{ display: reconstructedObject ? (reconstructedObject.CashIn === "Y" ? "flex" : "none") : "flex" }}>
                    <p className="till-summary__label">{getMultilingualText("Cash In")}</p>
                    <p className="till-summary__value">{currenciesList[0].currSymbol}0</p>
                  </div>

                  <div className="till-summary__row" style={{ display: reconstructedObject ? (reconstructedObject.CashOut === "Y" ? "flex" : "none") : "flex" }}>
                    <p className="till-summary__label">{getMultilingualText("Cash Out")}</p>
                    <p className="till-summary__value">{currenciesList[0].currSymbol}0</p>
                  </div>

                  <div className="till-summary__row" style={{ display: reconstructedObject ? (reconstructedObject.PettyCashIn === "Y" ? "flex" : "none") : "flex" }}>
                    <p className="till-summary__label">{getMultilingualText("Petty Cash In")}</p>
                    <p className="till-summary__value">{currenciesList[0].currSymbol}0</p>
                  </div>

                  <div className="till-summary__row" style={{ display: reconstructedObject ? (reconstructedObject.PettyCashOut === "Y" ? "flex" : "none") : "flex" }}>
                    <p className="till-summary__label">{getMultilingualText("Petty Cash Out")}</p>
                    <p className="till-summary__value">{currenciesList[0].currSymbol}0</p>
                  </div>

                  <div className="till-summary__row" style={{ display: reconstructedObject ? (reconstructedObject.ExpectedCash === "Y" ? "flex" : "none") : "flex" }}>
                    <p className="till-summary__label">{getMultilingualText("Expected Cash")}</p>
                    <p className="till-summary__value">{currenciesList[0].currSymbol}0</p>
                  </div>

                  <div className="till-summary__row">
                    <p className="till-summary__label">{getMultilingualText("Actual Cash")}</p>
                    <p className="till-summary__value">{currenciesList[0].currSymbol}0</p>
                  </div>
                </Scrollbars>
                <div className="till-actions--sticky">
                  <Button
                    tabIndex={1}
                    disabled={isExecuting}
                    className="focusButtonsTill till-btn--primary-full"
                    ref={confirmBtnRef}
                    onClick={excuteOpenTill}
                  >
                    {getMultilingualText("Next")}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OpenTill;
